// 'TEST' or 'PRODUCTION'
let config = 'PRODUCTION';

export function getConfig() {
    return config === 'TEST' ?
    {
        serverUrl: 'http://localhost:9002',
        userPoolId: 'eu-central-1_DiWkgIkXf',
        clientId: '7gb7f0anm2gk3i3ptl0ld7o06u'
    }
    :
    {
        serverUrl: 'https://api.arboreal.se',
        userPoolId: 'eu-central-1_s3pY1grcE',
        clientId: '5ielkmm5smu3qpqr0evtb85ond'
    }
}
